<template>
  <div class="card">
    <div v-if="!onLoadEntity" class="card-body">
      <label v-if="this.$route.params.id && !onEdit" class="tw-flex tw-items-center tw-text-xs tw-font-medium">{{ $t('Template Name') }}</label>
      <div class="w-100 tw-flex mb-1">
        <div v-if="this.$route.params.id && !onEdit" style="min-width: fit-content">
          <label class="tw-flex tw-items-center tw-text-xl">{{ template.contractTemplate.name }}</label>
        </div>
        <div class="w-100 tw-justify-end">
          <div v-if="!this.$route.params.id" class="tw-flex">
            <b-button class="btn btn-primary" :disabled="loading" @click="saveContractTemplate">
                <span class="align-middle">{{ $t('Save') }}</span>
            </b-button>
            <b-button variant="outline-primary" @click="cancelNewContract" style="margin-left: 7px">
                <span class="align-middle">{{ $t('Cancel') }}</span>
            </b-button>
          </div>
          <div class="tw-flex tw-justify-end" v-else>
            <b-button class="btn btn-primary" v-if="!onEdit" @click="editContract">
                <span class="align-middle">{{ $t('Edit')}}</span>
            </b-button>
            <b-button class="btn btn-primary" v-if="onEdit" @click="saveEdit">
                <span class="align-middle">{{ $t('Save')}}</span>
            </b-button>

            <b-button style="margin-left: 7px" variant="outline-primary" v-if="onEdit" @click="cancelEdit">
                <span class="align-middle">{{ $t('Cancel') }}</span>
            </b-button>
          </div>
        </div>
      </div>

      <div v-if="!this.$route.params.id || onEdit">
        <label class="tw-flex tw-items-center tw-text-xs tw-font-medium">{{$t('Template Name')}}</label>
        <prozess-input
            id="name"
            v-model="template.contractTemplate.name"
            field="name"
            name="name"
            :error="errorField.includes('name') ? $t('Required') : ''"
            style="padding-top: 0px"
          />
      </div>
      <div>
        <div class="row mb-0 ml-0 tw-pt-3 pt-0 mb-1">
          <label class="tw-flex tw-items-center tw-text-xs tw-font-medium">{{ $t('PDF Template') }}</label>
          <input
            class="w-100"
            ref="fileExplorer"
             v-if="template.contractTemplate.file==null"
            type="file"
            accept=".pdf"
            style="padding-top: 0px;"
            @change="handleNewFileInputChange"
          />
          <p class="invalid-feedback" v-if="errorField.includes('file')">{{ $t('Required') }}</p>
          <div class="w-100 d-flex" v-if="template.contractTemplate.file!=null">
              <p style="padding: 2px 10px; margin-bottom:0px; background-color: rgba(255,255,255,0.1); border-radius: 4px; margin-right: 6px;">{{ template.contractTemplate.pdfFileName }}</p>
              <div v-if="onEdit || !this.$route.params.id" class='d-flex' style="align-items: center;">
                <label for="reupload-file" style="margin: 0px; cursor: pointer;text-decoration: underline; width: 90px;"> {{ $t('Replace PDF') }}</label>
                <input
                  ref="fileExplorer"
                  type="file"
                  id="reupload-file"
                  accept=".pdf"
                  style="padding-top: 0px;visibility:hidden;"
                  @change="handleNewFileInputChange"
                />
              </div>
          </div>
        </div>
      </div>
      <div
        class="forms__column--selectors tw-flex"
        :class="{ 'pointer-events-none': disableSelectors }"
      >
      </div>
      <div class="m-0 mb-1 mt-1">
        <label>
          <span class="tw-flex tw-items-center tw-text-xs tw-font-medium">{{ $t('Form Fields') }}</span>
        </label>
        <div v-if="!onLoadEntity" style="border-radius: 4px">
          <p class="mb-0 text-center" >{{
            template.contractTemplate.file ?
            (Object.values(wizard.pageFields).length === 0? $t('No Fields Available') : '' ) :
            $t('Upload File to Set Fields')}}</p>
          <div
            v-for="(pageNumber, i) of wizard.pages"
            :key="`pdf-page-${i}`"
            style="background-color: rgba(0,0,0,0.03); padding: 8px 10px; border-radius: 10px"
            class="mb-1">
            <div class="d-flex">
              <div style="width: 100%;" class="d-flex">
                <feather-icon icon="FileIcon" class="tw-mr-1 tw-mt-1" color="gray" />
                <p class="mb-0" style="margin-top:2px">{{ $t('Page ').concat(pageNumber) }}</p>
                <div class="selected-modules-bar" v-if="pageModules[pageNumber]" style="padding: 2px 6px; margin-left: 12px; display: flex;">
                  <div v-for="(modKey, i2) of pageModules[pageNumber]" :key="`pmods-${i2}`">
                      <p style="width: fit-content; background-color: rgb(160,160,160); color: white; margin-right: 6px; border-radius: 6px; padding: 2px 8px; font-size: 10px;">
                        {{ $t(getModuleName(modKey)) }}
                      </p>
                  </div>
                </div>
              </div>
              <div>
                <b-dropdown size="sm" variant="outline-primary" class="ml-1 mb-1">
                  <template #button-content>
                    <span class="text-nowrap">{{ $t('+ Module')  }}</span>
                  </template>
                  <b-dropdown-item
                    v-for="moduleOpt in pageModuleOptions"
                    :key="moduleOpt.id"
                    @click="addModule(pageNumber, moduleOpt)"
                  >
                  {{ $t(moduleOpt?.label) }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
              <div
                v-for="(pageField, i2) of wizard.pageFields[pageNumber]"
                :key="`page-field-${i2}`"
                style="margin-left: 20px; margin-bottom:8px;margin-top:6px; height: 40px; border-radius: 10px; align-items: center; padding:12px; background-color: rgba(0,0,0,0.03)"
                class="form-field-item d-flex"
               :class="{ 'page-field-error': errorField.includes(pageField.acroKey) && pageField.primary }"
                >
                <div class="d-flex" style="width: 30%">
                  <feather-icon icon="TypeIcon" class="tw-mr-1" style="margin-top:2px"/>
                  <p class="mb-0" >{{ pageField.acroKey }}</p>
                </div>
                <div v-if="!selectedInputType[pageField.acroKey] && onViewOnly()">
                  <p style="margin-bottom: 0px; color: white; background-color: lightgray; padding: 1px 6px; border-radius: 4px;">{{ $t("Not Mapped") }}</p>
                </div>
                <div class="d-flex" v-else-if="pageField.primary" style="width: 60%; align-items: center;">
                  <ProzessSelect
                    v-model="selectedInputType[pageField.acroKey]"
                    :options="getInputTypes(pageNumber)"
                    :disabled="onViewOnly()"
                    style="width: 220px;"
                  />
                  <ProzessSelect
                      v-if="selectedInputType[pageField.acroKey]?.key === 'map'"
                      v-model="selectedEntity[pageField.acroKey]"
                      :options="entityOptions"
                      :disabled="onViewOnly()"
                      style="width: 220px; margin-left: 8px;"
                    />
                  <ProzessSelect
                      v-else-if="selectedInputType[pageField.acroKey]?.key === 'auto'"
                      v-model="selectedAutoOption[pageField.acroKey]"
                      :options="autoOptions"
                      :disabled="onViewOnly()"
                      style="width: 220px; margin-left: 8px;"
                    />
                  <ProzessSelect
                      v-else-if="selectedInputType[pageField.acroKey]?.key === 'modules'"
                      v-model="selectedEntity[pageField.acroKey]"
                      :options="moduleOptions"
                      :disabled="onViewOnly()"
                      style="width: 220px; margin-left: 8px;"
                    />

                  <ProzessSelect
                      v-else-if="selectedInputType[pageField.acroKey]?.module_type === 'commission_model'"
                      v-model="selectedProduct[pageField.acroKey]"
                      :options="productOptions"
                      :disabled="onViewOnly()"
                      style="width: 220px; margin-left: 8px;"
                    />
                  <ProzessSelect
                    v-if="selectedInputType[pageField.acroKey]?.key === 'map' && selectedEntity[pageField.acroKey]"
                    v-model="selectedColumns[pageField.acroKey]"
                    :options="entityColumns[selectedEntity[pageField.acroKey].key]"
                    :disabled="onViewOnly()"
                    style="width: 220px; margin-left: 8px;"
                  />
                  <ProzessSelect
                    v-if="selectedInputType[pageField.acroKey]?.key === 'modules' && selectedEntity[pageField.acroKey]?.key === 'commission_model'"
                    v-model="selectedColumns[pageField.acroKey]"
                    :options="moduleFieldOptions"
                    :disabled="onViewOnly()"
                    style="width: 220px; margin-left: 8px;"
                  />
                  <ProzessSelect
                    v-if="selectedInputType[pageField.acroKey]?.key === 'modules' && selectedEntity[pageField.acroKey]?.key === 'company_subsidiary'"
                    v-model="selectedColumns[pageField.acroKey]"
                    :options="subsidiaryFields"
                    :disabled="onViewOnly()"
                    style="width: 220px; margin-left: 8px;"
                  />
                </div>
                <div v-else>
                  <p v-if="!onViewOnly()" style="color:gray; margin-bottom: 0px; background-color: rgb(81, 173, 124); color: white; padding: 3px 6px; border-radius: 4px;">
                    <span>{{ $t("*Set mapping on Page ") }}</span>
                    <span>{{ pageField.primaryPage }}</span>
                  </p>
                </div>
                <div class="d-flex" v-if="selectedInputType[pageField.acroKey] != null">
                   <feather-icon
                    v-if="canCopy(pageField.acroKey)"
                    :id="`tooltip-${pageField.acroKey}-${i2}clone`"
                    class="mx-1 cursor-pointer"
                    icon="CopyIcon"
                    size="19"
                   @click="copyOne(pageField.acroKey)"
                  />
                </div>
                   <feather-icon
                    v-if="copy.length > 0"
                    :id="`tooltip-paste-${pageField.acroKey}-${i2}clone`"
                    class="cursor-pointer"
                    icon="ClipboardIcon"
                    size="19"
                   @click="pasteOne(pageField.acroKey)"
                  />
              </div>
          </div>
        </div>
      </div>
      <div class="row col-sm-5 col-md-4 col-12">
          <b-button id="sel-reset-button" variant="outline-primary" class="mr-1" @click="testGenerateContract">
            <span class="align-middle">{{ $t('Test Generate') }}</span>
          </b-button>
        </div>
    </div>

    <div
        v-if="loading || onLoadEntity"
        class="d-flex justify-content-center align-items-center"
        style="height: 100px"
      >
        <b-spinner class="align-middle" />
      </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import ProzessInput from '@core/components/ProzessInput.vue'
import API from '@axios'
import contractTemplateService from '@/services/contractTemplate'
import authUserService from '@/services/authUser'
import ProzessSelect from '@/@core/components/ProzessSelect.vue'

export default {

  components: {
    ProzessSelect,
  },
  props: {
  },
  data() {
    return {
      showForm: false,
      fieldOptions: [],
      entities: [],
      inputTypes: [
        { key: 'map', label: 'Kartlegging' }, // Mapping
        { key: 'manual', label: 'Manuell inngang' }, // Manual Input
        { key: 'auto', label: 'Automatisk innstilling' }, // Auto-set
        { key: 'modules', label: 'Moduler' }, // Modules
      ], //
      entityOptions: [],
      autoOptions: [
        { key: 'date', label: 'Dato for generasjon' }, // Date of generation
      ],
      pageModuleOptions: [{ key: 'commission_model', label: 'Commission Model' }],
      moduleOptions: [{ key: 'commission_model', label: 'Commission Model' }, { key: 'company_subsidiary', label: 'Company Subsidiary' }],
      moduleFieldOptions: [
        { key: 'model_name', label: 'Modellnavn' }, // Model Name
        { key: 'agreement_type', label: 'Avtaletype' }, // Agreement Type
        { key: 'year', label: 'Årstal' }, // Year
      ],
      subsidiaryFields: [
        { key: 'sf_company_name', label: 'Selskapsnavn' },
        { key: 'sf_org_nr', label: 'Forsikringsagentforetakets Org.Nr' },
        { key: 'sf_agent_name', label: 'Forsikringsagentforetakets Navn' },
        { key: 'sf_postal_address', label: 'Postadresse' },
        { key: 'sf_kategori', label: 'Kategori' },
        { key: 'sf_account_nr', label: 'Kontonummer' },
        { key: 'sf_agent_nr_enter', label: 'Agentnummer Enter' },
        { key: 'sf_agent_nr_tryg', label: 'Agentnummer Tryg' },
        { key: 'sf_varkontakt', label: 'Var kontakt' },
        { key: 'sf_mobile', label: 'Mobile' },
        { key: 'sf_email', label: 'Email' },
        { key: 'sf_fornavn', label: 'Fornavn' },
        { key: 'sf_etternavn', label: 'Etternavn' },
        { key: 'sf_navn', label: 'Navn' },
        { key: 'sf_epost', label: 'Epost' },
        { key: 'sf_idd_role', label: 'IDD Rolle' },
      ],
      entityColumns: [],
      selectedInputType: {},
      selectedEntity: {},
      selectedAutoOption: {},
      selectedProduct: {},
      selectedColumns: {},
      template: {},
      baseTemplate: {},
      baseSelectedEntity: {},
      baseSelectedColumns: {},
      wizard: {},
      baseSelectedProduct: {},
      baseWizard: {},
      onEdit: false,
      errorField: [],
      onLoadEntity: false,
      pageModules: {},
      commissionModuleOptions: [
      { key: 'level_range_from', label: 'Provisjon (Nivå): Fra', type: 'page_module', module_type: 'commission_model' },
      { key: 'level_range_to', label: 'Provisjon (Nivå): Til', type: 'page_module', module_type: 'commission_model' },
      { key: 'level_range_percentage', label: 'Provisjon (Nivå): Prosentdel', type: 'page_module', module_type: 'commission_model' },
      { key: 'level_range_rate', label: 'Provisjon (Nivå): Rate', type: 'page_module', module_type: 'commission_model' },
      ],
      productOptions: [{ key: 'enter', label: 'Enter Privat' }, { key: 'tryg', label: 'Tryg Privat' }, { key: 'enter_naring', label: 'Enter proff' }],
      copy: [],
    }
  },
  mounted() {
  },
  async created() {
    await this.getEntities()
    if (this.$route.params.id) {
      this.setTemplateData()
    } else {
      this.template = {
        contractTemplate: {
          pdfFileName: '',
          file: null,
        },
        formFieldMap: {},
      }
    }
  },
  methods: {
    ...mapMutations({
      setResource: 'form/SET_RESOURCE',
      setUserFields: 'user/SET_USER_FIELDS',
    }),
    canCopy(acroKey) {
        if (this.selectedInputType[acroKey] == null) {
          return false
        }
        if (this.selectedInputType[acroKey]?.key === 'map' && this.selectedEntity[acroKey] != null && this.selectedColumns[acroKey] != null) {
          return true
        }
        if (this.selectedInputType[acroKey]?.key === 'manual') {
          return true
        }
        if (this.selectedInputType[acroKey]?.key === 'auto' && this.selectedAutoOption[acroKey] != null) {
          return true
        }
        if (this.selectedInputType[acroKey]?.key === 'modules' && this.selectedEntity[acroKey] != null && this.selectedColumns[acroKey] != null) {
          return true
        }
        if ((this.selectedInputType[acroKey]?.key === 'level_range_from' ||
          this.selectedInputType[acroKey]?.key === 'level_range_to' ||
          this.selectedInputType[acroKey]?.key === 'level_range_percentage' ||
          this.selectedInputType[acroKey]?.key === 'level_range_from' ||
          this.selectedInputType[acroKey]?.key === 'level_range_rate') &&
          this.selectedProduct[acroKey] != null) {
          return true
        }
    },
    copyOne(acroKey) {
       const cop = {
            inputType: this.selectedInputType[acroKey],
            fieldName: this.selectedColumns[acroKey],
        }
        if (this.selectedInputType[acroKey]?.key === 'map' || this.selectedInputType[acroKey]?.key === 'modules') {
          cop.inputSubType = this.selectedEntity[acroKey]
        } else if (this.selectedInputType[acroKey]?.key === 'auto') {
          cop.inputSubType = this.selectedAutoOption[acroKey]
        }
        if (this.selectedInputType[acroKey]?.key === 'manual') {
          cop.fieldName = null
          cop.inputSubType = null
        } else if ((
          this.selectedInputType[acroKey]?.key === 'level_range_from' ||
          this.selectedInputType[acroKey]?.key === 'level_range_to' ||
          this.selectedInputType[acroKey]?.key === 'level_range_percentage' ||
          this.selectedInputType[acroKey]?.key === 'level_range_from' ||
          this.selectedInputType[acroKey]?.key === 'level_range_rate')) {
          cop.inputSubType = this.selectedProduct[acroKey]
        } else if (this.selectedInputType[acroKey]?.key === 'modules') {
          cop.aa = ''
        }
        this.copy = [cop]
    },
    pasteOne(acroKey) {
      this.selectedInputType[acroKey] = JSON.parse(JSON.stringify(this.copy[0].inputType))
      if (this.selectedInputType[acroKey]?.key === 'map' || this.selectedInputType[acroKey]?.key === 'modules') {
        this.selectedEntity[acroKey] = JSON.parse(JSON.stringify(this.copy[0].inputSubType))
       this.$forceUpdate()
      } else if (this.selectedInputType[acroKey]?.key === 'auto') {
        this.selectedAutoOption[acroKey] = JSON.parse(JSON.stringify(this.copy[0].inputSubType))
       this.$forceUpdate()
      } else if ((
          this.selectedInputType[acroKey]?.key === 'level_range_from' ||
          this.selectedInputType[acroKey]?.key === 'level_range_to' ||
          this.selectedInputType[acroKey]?.key === 'level_range_percentage' ||
          this.selectedInputType[acroKey]?.key === 'level_range_from' ||
          this.selectedInputType[acroKey]?.key === 'level_range_rate')) {
            this.selectedProduct[acroKey] = JSON.parse(JSON.stringify(this.copy[0].inputSubType))
      }
      this.selectedColumns[acroKey] = JSON.parse(JSON.stringify(this.copy[0].fieldName))
       this.$forceUpdate()
    },
    addModule(pageNum, mod) {
      if (this.pageModules[pageNum] == null) {
        this.pageModules[pageNum] = [mod.key]
      } else if (this.pageModules[pageNum].includes(mod.key) === false) {
          const pMods = this.pageModules[pageNum]
          pMods.push(mod.key)
          this.pageModules[pageNum] = pMods
      }
      this.selectedInputType = JSON.parse(JSON.stringify(this.selectedInputType)) // refresh dropdown
    },
    getModuleName(key) {
      return this.moduleOptions.filter(m => m.key === key)[0].label
    },
    getInputTypes(pageNum) {
      let inTypes = JSON.parse(JSON.stringify(this.inputTypes))
      if (this.pageModules[pageNum] != null) {
        if (this.pageModules[pageNum].includes('commission_model')) {
          inTypes = inTypes.concat(this.commissionModuleOptions)
        }
        // if (this.pageModules[pageNum].includes('company_subsidiary')) {
        //   inTypes = inTypes.concat(this.subsidiaryFields)
        // }
      }
      return inTypes
    },
    onViewOnly() {
      return this.$route.params.id != null && !this.onEdit
    },
    getInputTypeFromKey(key) {
      return this.inputTypes.filter(it => it.key === key)[0]
    },
    getModuleOptionFromKey(key) {
      return this.moduleOptions.filter(it => it.key === key)[0]
    },
    getAutoTypeFromKey(key) {
      return this.autoOptions.filter(it => it.key === key)[0]
    },
    async mapFields() {
      this.loading = true
      this.selectedInputType = {}
      // mapping
      this.selectedEntity = {}
      this.selectedColumns = {}

      // auto
      this.selectedAutoOption = {}
      Object.keys(this.template.formFieldMap).forEach(ff => {
        const formField = this.template.formFieldMap[ff]
        const sEntity = this.entities[formField.metaKey]
        if (formField.type === 'page_module') {
            this.selectedInputType[ff] = this.getModuleFieldOptions().filter(mF => mF.key === formField.fieldKey)[0]
            if (formField.key === 'commission_model') {
              this.selectedProduct[ff] = this.productOptions.filter(pO => pO.key === formField.metaKey)[0]
            }
            const pageNumberx = this.getPageNumber(formField.acroKey)
            if (this.pageModules[pageNumberx] == null) {
              this.pageModules[pageNumberx] = []
            }
            if (!this.pageModules[pageNumberx].includes(formField.key)) {
              this.pageModules[pageNumberx].push(formField.key)
            }
        } else {
              this.selectedInputType[ff] = this.getInputTypeFromKey(formField.type)
              if (formField.type === 'modules') {
                this.selectedEntity[ff] = this.getModuleOptionFromKey(formField.metaKey)
                this.selectedColumns[ff] = this.getModuleField(formField.metaKey, formField.fieldKey)
              } else if (formField.type === 'map') {
                this.selectedAutoOption[ff] = this.getAutoTypeFromKey(formField.key)
                this.selectedEntity[ff] = {
                  key: formField.metaKey,
                  label: sEntity.label,
                  entityKey: sEntity.key,
                  relationshipId: sEntity.relationshipId,
                  schema: sEntity.schema,
                  type: sEntity.type,
                }
                this.selectedColumns[ff] = {
                  key: formField.fieldKey,
                  label: sEntity.columns[formField.fieldKey].label,
                }
              } else if (formField.type === 'auto') {
                this.selectedAutoOption[ff] = this.getAutoTypeFromKey(formField.key)
              }
        }
      })
      this.loading = false
    },
    getPageNumber(acroK) {
      let ppage = null
      Object.keys(this.wizard.pageFields).forEach(pN => {
        if (ppage == null) {
          const fieldsz = this.wizard.pageFields[pN].map(pFields => pFields.acroKey)
          if (fieldsz.includes(acroK)) {
            ppage = pN
          }
        }
      })
      return ppage
    },
    async setTemplateData() {
      this.loading = true
      const { id } = this.$route.params
      const { response } = await this.$async(contractTemplateService.getTemplateById(id))
      const formFieldMap = response.data.formFieldMap
      this.wizard = {
        formFieldMap: response.data.formFieldMap,
        pageFields: response.data.pageFields,
        pages: Object.keys(response.data.pageFields),
      }
      this.template = response.data.template
      await this.mapFields()
      this.$forceUpdate()
      this.remap()
      this.template.contractTemplate.file = await contractTemplateService.b64toBlob(this.template.contractTemplate.rawPdf, 'application/pdf')
      this.$forceUpdate()
      this.loading = false
    },
    remap() {
      this.template = JSON.parse(JSON.stringify(this.template))
      this.selectedEntity = JSON.parse(JSON.stringify(this.selectedEntity))
      this.selectedColumns = JSON.parse(JSON.stringify(this.selectedColumns))
      this.wizard = JSON.parse(JSON.stringify(this.wizard))
      this.selectedInputType = JSON.parse(JSON.stringify(this.selectedInputType))
    },
    resetLocalState() {
      this.entityOptions = []
    },
    async getEntities() {
      this.onLoadEntity = true
      const { response } = await this.$async(contractTemplateService.getEntities())
      this.entities = response.data
      this.entityOptions = Object.values(this.entities).map(e => ({ key: e.metaKey, label: e.label, relationshipId: e.relationshipId, schema: e.schema, type: e.type, entityKey: e.key }))
      this.entityColumns = {}
       Object.values(this.entities).forEach(en => {
        this.entityColumns[en.metaKey] = Object.values(en.columns)
       })
      this.onLoadEntity = false
      this.$forceUpdate()
    },

  async updateWithNewFile(file) {
    await contractTemplateService.getFormFields(file).then(res => {
      this.wizard = res.data
      this.wizard.pages = Object.keys(this.wizard.pageFields)
      this.loading = false
      })
      .finally(() => {
        this.loading = false
      })
  },
  async handleNewFileInputChange(e) {
    this.loading = true
    const errorIndex = this.errorField.indexOf('file')
    if (errorIndex !== -1) {
      this.errorField.splice(errorIndex, 1)
    }

    const [file] = e.target.files
    this.template.contractTemplate.file = file
    this.template.contractTemplate.pdfFileName = file.name
    await this.updateWithNewFile(file)
    this.loading = false
  },
  async editContract() {
    this.baseTemplate = JSON.parse(JSON.stringify(this.template))
    this.baseSelectedEntity = JSON.parse(JSON.stringify(this.selectedEntity))
    this.baseSelectedAuto = JSON.parse(JSON.stringify(this.selectedEntity))
    this.baseSelectedColumns = JSON.parse(JSON.stringify(this.selectedColumns))
    this.baseWizard = JSON.parse(JSON.stringify(this.wizard))
    this.baseSelectedInputType = JSON.parse(JSON.stringify(this.selectedInputType))
    this.baseSelectedProduct = JSON.parse(JSON.stringify(this.selectedProduct))
    this.template.contractTemplate.file = await contractTemplateService.b64toBlob(this.template.contractTemplate.rawPdf, 'application/pdf')
    this.onEdit = true
  },
  saveEdit() {
   this.updateContractTemplate()
   // cleanup
    const formFieldMap = this.enrichFormFieldMap()
      Object.keys(this.selectedInputType).forEach(k => {
          if (formFieldMap[k] == null && this.selectedInputType[k].key !== 'manual') {
            this.selectedInputType[k] = null
          }
      })
  },
  async cancelEdit() {
    this.template = JSON.parse(JSON.stringify(this.baseTemplate))
    this.template.contractTemplate.file = await contractTemplateService.b64toBlob(this.template.contractTemplate.rawPdf, 'application/pdf')
    this.selectedEntity = JSON.parse(JSON.stringify(this.baseSelectedEntity))
    this.selectedColumns = JSON.parse(JSON.stringify(this.baseSelectedColumns))
    this.wizard = JSON.parse(JSON.stringify(this.baseWizard))
    this.selectedInputType = JSON.parse(JSON.stringify(this.baseSelectedInputType))
    this.selectedProduct = JSON.parse(JSON.stringify(this.baseSelectedProduct))
    this.onEdit = false
  },
  cancelNewContract() {
    this.$router.push({ name: 'document-template' })
  },
   removeEmpty(obj) {
      return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null))
  },
  getModuleField(module, fieldKey) {
    switch (module) {
      case 'commission_model': return this.moduleFieldOptions.filter(mF => mF.key === fieldKey)[0]
      case 'company_subsidiary': return this.subsidiaryFields.filter(mF => mF.key === fieldKey)[0]
      default: return []
    }
  },
  getModuleFieldOptions() {
    return [].concat(this.commissionModuleOptions).concat(this.subsidiaryFields) // add more special fields here
  },
  enrichFormFieldMap() {
    const formFieldMap = {}
    this.selectedEntity = this.removeEmpty(this.selectedEntity)
    this.selectedInputType = this.removeEmpty(this.selectedInputType)

    // Page Module mapping
    Object.keys(this.selectedInputType).forEach((key, idx) => {
      const inputTypp = this.selectedInputType[key].key
      const moduleField = this.getModuleFieldOptions().filter(mF => mF.key === inputTypp)[0]
      if (moduleField != null) {
        const formField = {
              acroKey: key,
              type: moduleField.type,
              key: moduleField.module_type,
              fieldKey: moduleField.key,
              metaKey: this.selectedProduct[key].key,
            }
        formFieldMap[key] = formField
      }
    })

    Object.keys(this.selectedEntity).forEach((key, idx) => {
        if (this.selectedInputType[key]?.key === 'map') {
          if (this.selectedEntity[key] != null) {
            const formField = {
              acroKey: key,
              metaKey: this.selectedEntity[key].key,
              relationshipId: this.selectedEntity[key].relationshipId,
              schema: this.selectedEntity[key].schema,
              // type: this.selectedEntity[key].type,
              type: 'map',
              key: this.selectedEntity[key].entityKey,
              fieldKey: this.selectedColumns[key].key,
            }
            formFieldMap[key] = formField
          }
        } else if (this.selectedInputType[key]?.key === 'modules') {
          if (this.selectedEntity[key] != null && this.selectedColumns[key] != null) {
            const formField = {
              acroKey: key,
              metaKey: this.selectedEntity[key].key,
              type: 'modules',
              fieldKey: this.selectedColumns[key].key,
            }
            formFieldMap[key] = formField
          }
        }
      })

      Object.keys(this.selectedAutoOption).forEach((key, idx) => {
        if (this.selectedInputType[key]?.key === 'auto' && this.selectedAutoOption[key]?.key != null) {
          const formField = {
              acroKey: key,
              type: 'auto',
              key: this.selectedAutoOption[key].key,
            }
            formFieldMap[key] = formField
        }
      })
      Object.keys(this.selectedInputType).forEach(key => {
        if (this.selectedInputType[key]?.key === 'manual') {
        const formField = {
              acroKey: key,
              type: 'manual',
            }
            formFieldMap[key] = formField
        }
      })
      // console.log('formFieldMap', formFieldMap)
      return formFieldMap
  },
  saveContractTemplate() {
      this.errorField = []
      Object.keys(this.selectedInputType).forEach((key, idx) => {
        if (this.selectedInputType[key].module_type === 'commission_model' && this.selectedProduct[key] == null) {
          this.errorField.push(key)
        }
      })
      if (this.template.contractTemplate.name === '' || this.template.contractTemplate.name == null) {
        this.errorField.push('name')
      }
      if (this.template.contractTemplate.file == null) {
        this.errorField.push('file')
      }
      if (this.errorField.length === 0) {
        this.loading = true
        const formData = new FormData()
        formData.append('name', this.template.contractTemplate.file.name)
        formData.append('file', this.template.contractTemplate.file)
        const formFieldMap = this.enrichFormFieldMap()
        const contractTemplateReq = {
          name: this.template.contractTemplate.name,
          pdfFileName: this.template.contractTemplate.pdfFileName,
          formFieldMap,
        }
        formData.append('contractTemplateReq',
        new Blob([JSON.stringify(contractTemplateReq)], {
        type: 'application/json',
        }))
        API.put('/api/crm/contract/wizard/create', formData).then(res => {
          this.$router.push({ name: 'document-template' })
        })
        .finally(() => {
          this.loading = false
        })
      }
  },
  updateContractTemplate() {
      this.loading = true
      const formData = new FormData()
      formData.append('name', this.template.contractTemplate.file.name)
      formData.append('file', this.template.contractTemplate.file)
      const contractTemplateReq = {
        id: this.template.contractTemplate.id,
        name: this.template.contractTemplate.name,
        pdfFileName: this.template.contractTemplate.pdfFileName,
        formFieldMap: this.enrichFormFieldMap(),
      }

      formData.append('contractTemplateReq',
      new Blob([JSON.stringify(contractTemplateReq)], {
      type: 'application/json',
      }))
      API.put('/api/crm/contract/wizard/update', formData).then(res => {
        this.onEdit = false
        this.baseTemplate = JSON.parse(JSON.stringify(this.template))
        this.baseSelectedEntity = JSON.parse(JSON.stringify(this.selectedEntity))
        this.baseSelectedColumns = JSON.parse(JSON.stringify(this.selectedColumns))
        this.baseWizard = JSON.parse(JSON.stringify(this.wizard))
        this.$router.push()
      })
      .finally(() => {
        this.loading = false
      })
      this.loading = false
  },
  async testGenerateContract() {
      this.loading = true
      const formData = new FormData()
      formData.append('name', this.template.contractTemplate.file.name)
      formData.append('file', this.template.contractTemplate.file)
      const contractTemplateReq = {
        name: this.template.contractTemplate.name,
        pdfFileName: this.template.contractTemplate.pdfFileName,
        formFieldMap: this.enrichFormFieldMap(),
      }
      formData.append('contractTemplateReq',
      new Blob([JSON.stringify(contractTemplateReq)], {
      type: 'application/json',
      }))
      await API.put('/api/crm/contract/wizard/test-generate', formData).then(async res => {
         const mockContractTemplateResponse = res.data
         contractTemplateService.viewRawPdfFileInNewTab(mockContractTemplateResponse.contractTemplate.rawPdf)
       })

      this.loading = false
  },

  async getUserFields() {
      const { response } = await this.$async(authUserService.getUserFields())
      this.setUserFields(response.data)
    },

  },
}
</script>
<style lang="scss">
.dd{
display:flex;
flex-direction:row;
justify-content:space-between;
align-items:center;
}
.page-field-error{
  background-color: rgb(238, 232, 232) !important;
}
</style>
